import { createContext } from 'react'
import { NpsQuestionSet, NpsResponseValue } from '../types/nps.types'

export type NpsStatus = 'idle' | 'open' | 'submitting' | 'thankyou'

export interface NpsContextValue {
    activeSet: NpsQuestionSet | null
    responses: Record<string, NpsResponseValue | undefined>
    errors: Record<string, string>
    status: NpsStatus
    triggerNps: (questionSetId: string) => void
    setResponse: (questionId: string, value: NpsResponseValue | undefined) => void
    submit: () => Promise<void>
    close: () => void
}

export const NpsContext = createContext<NpsContextValue | null>(null)
